module.exports = __webpack_public_path__ + "static/media/logo-black.cf73b6dd.svg";